import { FilterMatchMode } from "primereact/api";

export class InstitucionPep {
    model = {
        id: { value: null, export: false, table: true, header: 'Código', isNumeric: true, filter: true, matchMode: FilterMatchMode.EQUALS, headerStyle: { width: '9%', minWidth: '9rem' } },
        razon_social: {
            value: '', export: true, header: 'Razón Social', required: 'Campo requerido', table: true, filter: true,
            maxLength: 'Máximo 500 caracteres', minLength: 'Mínimo 4 caracteres', max: 500, min: 4,
            filterField: 'razon_social', filterPlaceholder: 'Buscar Razón Social', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '30%', minWidth: '20rem' }
        },
        ruc: {
            value: '', export: true, header: 'Ruc', required: 'Ruc es requerido', table: true, filter: true, sort: true,
            maxLength: 'Máximo 13 caracteres', minLength: 'Mínimo 13 caracteres', max: 50, min: 4,
            filterField: 'ruc', filterPlaceholder: 'Buscar por ruc', matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '15%', minWidth: '15rem' }
        },
        url_directorio: {
            value: '', export: true, header: 'Url Directorio', required: false, table: false,
            maxLength: 'Máximo 3000 caracteres', minLength: 'Mínimo 4 caracteres', max: 3000, min: 4
        },
        url_remuneracion: {
            value: '', export: true, header: 'Url Remuneración', required: false, table: false,
            maxLength: 'Máximo 3000 caracteres', minLength: 'Mínimo 4 caracteres', max: 3000, min: 4
        },
        periodo_datos: {
            value: '', export: true, header: 'Periodo (MM/YYYY)', required: false, table: true, filter: true,
            filterPlaceholder: 'Ej. 12/2025', matchMode: FilterMatchMode.CONTAINS,
        },
        observacion: {
            value: '', export: true, header: 'Observación', required: false, table: true, filter: false, headerStyle: { width: '20%', minWidth: '15rem' }
        },
        estado: {
            value: null, export: true, header: 'Estado', required: 'Estado es requerido', table: true, sort: false,
        },
        // Mantenemos estos ocultos en la tabla pero en el modelo para el payload si se necesitan en otro momento
        c_nombre: { value: 0, export: false, table: false },
        c_pit: { value: 0, export: false, table: false },
        c_rmu_anual: { value: -1, export: false, table: false },
        c_rmu_mensual: { value: -1, export: false, table: false },
        c_cedula: { value: -1, export: false, table: false },
        pagina: { value: 1, export: false, table: false },
        separacion: { value: null, export: false, table: false }
    }

    optionLabel = 'nombre';

    // Lista de estados en la base (0 al 5)
    estadosOpciones = [
        { cat_id: 0, nombre: 'Inactivo' },
        { cat_id: 1, nombre: 'Activo' },
        { cat_id: 2, nombre: 'Pendiente' },
        { cat_id: 3, nombre: 'Proceso Individual' },
        { cat_id: 4, nombre: 'Proceso Masivo' },
        { cat_id: 5, nombre: 'Finalizado' }
    ];
}